import { Outlet } from "react-router";
import { BrandMark } from "./Brand";

export function AuthShell() {
  return (
    <div className="relative flex min-h-dvh flex-col items-center justify-center overflow-hidden bg-gradient-to-br from-primary via-primary to-accent px-4 py-10 pt-[calc(2.5rem+var(--spacing-safe-top))] pb-[calc(2.5rem+var(--spacing-safe-bottom))] dark:from-[#0b1220] dark:via-[#0f1a33] dark:to-accent/70">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 opacity-[0.12]"
        style={{
          backgroundImage: "radial-gradient(rgba(255,255,255,0.9) 1px, transparent 1px)",
          backgroundSize: "22px 22px",
        }}
      />
      <div aria-hidden className="pointer-events-none absolute -right-32 -top-32 size-96 rounded-full bg-accent/40 blur-3xl" />
      <div aria-hidden className="pointer-events-none absolute -bottom-40 -left-24 size-96 rounded-full bg-white/10 blur-3xl" />

      <div className="relative z-10 flex w-full max-w-md flex-col items-center gap-5">
        <div className="flex flex-col items-center gap-2 text-white">
          <BrandMark className="size-14 rounded-xl bg-white/15 text-white shadow-lg ring-1 ring-white/20 backdrop-blur dark:text-white" />
          <span className="font-display text-2xl font-bold tracking-tight">PB-Ranks</span>
          <span className="text-sm text-white/70">Your personal bests... Ranked</span>
        </div>
        <div className="w-full rounded-xl border border-border bg-surface p-6 text-fg shadow-2xl">
          <Outlet />
        </div>
        <p className="text-center text-xs text-white/60">
          <a href="/privacy" className="hover:text-white hover:underline">Privacy</a>
          <span className="mx-2">·</span>
          <a href="/terms" className="hover:text-white hover:underline">Terms</a>
        </p>
      </div>
    </div>
  );
}
